module.exports = __webpack_public_path__ + "img/bg_antwerp.1c232fbd.jpg";